<template>
  <b-row>
    <b-col md="12">
      <b-card v-if="$route.params.id">
        <b-row class="align-items-center">
          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('application_number')}}</h6>
              <small>#{{ GET_APPLICATIONS_TRANSPORT_ID.id }}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('date')}}</h6>
              <small>{{ $dayjs(GET_APPLICATIONS_TRANSPORT_ID.created_at).format("DD.MM.YYYY") }}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('author')}}</h6>
              <div class="d-flex">
                <small v-if="GET_APPLICATIONS_TRANSPORT_ID.author">{{
                  GET_APPLICATIONS_TRANSPORT_ID.author.first_name
                }}</small>
                <small
                  v-if="GET_APPLICATIONS_TRANSPORT_ID.author"
                  class="ml-50"
                  >{{ GET_APPLICATIONS_TRANSPORT_ID.author.last_name }}</small
                >
              </div>
            </div>
          </b-col>

          <b-col class="col-md-3">
            <div class="flex_column align-items-center">
              <h6 class="font-weight-bolder">{{$t('status')}}</h6>
              <b-badge
                v-if="GET_APPLICATIONS_TRANSPORT_ID.status"
                :variant="GET_APPLICATIONS_TRANSPORT_ID.status.color"
              >
                {{ GET_APPLICATIONS_TRANSPORT_ID.status.name }}
              </b-badge>
            </div>
          </b-col>
          <b-col v-if="GET_APPLICATIONS_TRANSPORT_ID.status" class="col-md-3">
            <div
              class="d-flex flex-wrap justify-content-end align-items-center"
            >
              <template
                v-for="(item, index) in GET_APPLICATIONS_TRANSPORT_ID.status
                  .change_to"
              >
                <b-button
                  :key="index"
                  v-if="checkButtonPermission([...item.roles, 'admin'])"
                  size="sm"
                  class="ml-50"
                  style="margin: 3px 0"
                  :variant="item.color"
                  :disabled="checkAndDisableStatusIfNeeded(item)"
                  @click="onChangeStatus(GET_APPLICATIONS_TRANSPORT_ID, item)"
                >
                  {{ item.name }}
                </b-button>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col cols="9">
      <b-card>
        <b-tabs>
          <b-tab active :title="$t('applications')">
            <div class="d-flex flex-wrap">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pb-50
                  w-100
                "
              >
                <h6 class="mb-0 font-weight-bolder">{{$t('reference.material')}}</h6>
              </div>

              <b-table
                class="table-bordered border"
                :fields="fields"
                :items="GET_APPLICATIONS_TRANSPORT_ID.transports"
                show-empty
                hover
                responsive
                :empty-text="$t('empty_text')"
              >
                <!-- <template #row-details="row">
                  <span v-if="row.item && row.item.responsible">
                    {{$t('contact.comment')}}: {{ row.item.responsible }}
                  </span>
                </template> -->

                <template #head()="props">
                  <span>{{ $t(props.label) }}</span>
                </template>

                <template #cell(index)="{ index }">
                  <span>{{ index + 1 }}</span>
                </template>


                <template #cell(start_date)="props">
                  <div>
                      {{ props.item && props.item.start_date ? $dayjs(props.item.start_date).format('DD.MM.YYYY, HH:mm') : '-' }}
                  </div>
                </template>

                <template #cell(image)="props">
                  <b-img :src="props.item && props.item.transport && props.item.transport.image ? props.item.transport.image : '' "
                    alt="" width="180" />
                </template>

                <template #cell(transports)="props">
                  <div>
                      {{ props.item && props.item.transport && props.item.transport.title ? props.item.transport.title : '-' }}
                  </div>
                </template>

                <template #cell(price_per_hour)="props">
                  <div>
                      {{ props.item && props.item.price_per_hour ? $_formatPriceMixin(props.item.price_per_hour) : '-' }}
                  </div>
                </template>

                <template #cell(working_hours)="props">
                  <div>
                      {{ props.item && props.item.working_hours ? $_formatPriceMixin(props.item.working_hours) : '-' }}
                  </div>
                </template>

                <template #cell(sum_total)="props">
                  <div>
                      {{ props.item && props.item.working_hours && props.item.price_per_hour ? $_formatPriceMixin(props.item.price_per_hour * props.item.working_hours) : '-' }}
                  </div>
                </template>

              </b-table>

              <div
                class="
                  mt-2
                  mb-2
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="d-flex">
                  <h6 class="mb-0 font-weight-bolder">{{$t('sidebar.warehouse')}}:</h6>
                  <small
                    v-if="GET_APPLICATIONS_TRANSPORT_ID &&
                     GET_APPLICATIONS_TRANSPORT_ID.storage && 
                     GET_APPLICATIONS_TRANSPORT_ID.storage.title"
                    class="ml-50"
                  >
                    {{ GET_APPLICATIONS_TRANSPORT_ID.storage.title }}
                  </small>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
    <b-col cols="3">
      <b-card>
        <div class="d-flex flex-wrap">
          <app-timeline class="h-100 w-100">
            <app-timeline-item
              v-for="item in GET_APPLICATION_STATUS_TIMELINE.results"
              :key="item.id"
              :title="item.to_status.full_name + ' #' + item.object_id"
              :subtitle="item.author.first_name + item.author.last_name"
              :comment="(item.description ? item.description : '')"
              :icon="item.to_status.icon"
              :time="$dayjs(item.created_at).format('DD.MM.YYYY, HH:mm')"
              :variant="item.to_status.color"
              :author="true"
            />
          </app-timeline>
        </div>
      </b-card>
    </b-col>



    <b-modal
      ref="confirmOrRefuse"
      cancel-variant="outline-secondary"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      centered
      size="md"
      no-close-on-backdrop
      :title="$t('do_you_really_want') + ' ' + $t('refuse_this_application')"
      @ok="onStatusChangedAndSaved($event)"
    >
      <div>
        <validation-observer ref="confirmOrRefuseObserver">
          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea
                v-model="statusComment"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </div>
    </b-modal>

  </b-row>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BRow,
  BTable,
  VBTooltip,
  BTabs,
  BTab,
  BImg,
  BFormGroup,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";

import priceFormatMixin from "@/mixins/priceFormatMixin";
import { getUserData } from "@/auth/utils";
import check from "@/mixins/check";
import loader from "@/mixins/loader";
import { required } from "@core/utils/validations/validations";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BCard,
    BBadge,
    BTabs,
    BTab,
    BImg,

    AppTimeline,
    AppTimelineItem,

    AppCollapse,
    AppCollapseItem,

    ValidationObserver,
    ValidationProvider,

    BFormGroup,
    BFormInput,
    BFormTextarea,
    required,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [priceFormatMixin, check, loader],
  data() {
    return {





      // ===============  PRIMARY_DATA_SECTION START ===============
      userData: {},
      statusDeniedOrWaiting: '',
      statusComment: '',
      fields: [
        {
          label: "№",
          key: "index",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "time",
          key: "start_date",
           thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "photo",
          key: "image",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "transport",
          key: "transports",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "amount",
          key: "count",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "price_per_hour",
          key: "price_per_hour",
          thClass: "tableHeadClass",
        },
        {
          label: "hours_used",
          key: "working_hours",
          thClass: "tableHeadClass",
        },
        {
          label: "total_amount",
          key: "sum_total",
          thClass: "tableHeadClass",
        },
        {
          label: "contact.comment",
          key: "comment",
           thClass: "text-center",
          tdClass: "text-center",
        },
        // {
        //   label: "actions",
        //   key: "actions",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
      ],
      // ===============  PRIMARY_DATA_SECTION END ===============





    };
  },
  computed: {
    ...mapGetters("application", [
      "GET_APPLICATIONS_TRANSPORT_ID",
      "GET_APPLICATION_STATUS_TIMELINE",
    ]),
  },
  async mounted() {



    // await this.$_loaderStart();
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh();
    // ===============  PRIMARY_REQUESTS_SECTION END ===============
    this.userData = getUserData();




  },
  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "FETCH_APPLICATIONS_TRANSPORT_ID",
      "UPDATE_PATCH_APPLICATION_TRANSPORT",
      "FETCH_APPLICATION_STATUS_TIMELINE",
    ]),





    // ===============  OPEN_MODAL_SECTION START ===============

    // ===============  OPEN_MODAL_SECTION START ===============








    // ===============  REFRESH_SECTION START ===============
    async refresh() {
      await this.FETCH_APPLICATIONS_TRANSPORT_ID(this.$route.params.id)
        .then(async () => {
          await this.FETCH_APPLICATION_STATUS_TIMELINE({
            // id: this.$route.params.id,
            params: {
              content_type_model: "requirements_t",
              object_id: this.$route.params.id,
            },
          });
        })
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            this.$router.push("/applications/material");
          }
        });
    },
    // ===============  REFRESH_SECTION START ===============








    // ===============  CHECK_AND_DISABLE_SECTION START ===============
    checkAndDisableStatusIfNeeded(item) {
      if (item.unique_name == "closed") {
        let status = false;
        this.GET_APPLICATIONS_TRANSPORT_ID.objects.forEach((elem) => {
          if (elem.count > 0) {
            status = true;
          }
        });
        return status;
      } else if (item.unique_name == "in_consideration_on_main") {
        let status = true;
        this.GET_APPLICATIONS_TRANSPORT_ID.objects.forEach((elem) => {
          if (elem.remainder < elem.count) {
            status = false;
          }
        });
        return status;
      } else if (item.unique_name == "denied") {
        if (
          this.GET_APPLICATIONS_TRANSPORT_ID.write_off.length == 0 &&
          this.GET_APPLICATIONS_TRANSPORT_ID.status.unique_name ==
            "in_consideration"
        ) {
          return false;
        } else {
          return true;
        }
      } 
    },
    // ===============  CHECK_AND_DISABLE_SECTION START ===============










    // ===============  ON_CHANGE_STATUS_SECTION START ===============
    onChangeStatus(props, item) {
      const status = {
        on_way_requirements_transports: this.$t('send_on_the_way'),
        arrived_requirements_transports: this.$t('arrived'),
        closed_requirements_transports: this.$t('go_to_refused_status'),
        in_suppliers_consideration_transports: this.$t('submit_this_application_for_suppliers_review'),
        in_supervisors_consideration_transports: this.$t('submit_this_application_for_supervisors_review'),
        in_financiers_consideration_transports: this.$t('submit_this_application_for_financiers_review'),
        awaiting_paid_t: this.$t('switch_to_pending_payment_status'),
        paid_transports: this.$t('switch_to_paid_status2'),
      };

      this.statusId = props.id
      if(item.unique_name == 'denied_transports'){
        this.$refs['confirmOrRefuse'].show()
        this.statusDeniedOrWaiting = 'denied_transports'
      }else{
        this.$bvModal
          .msgBoxConfirm(
            this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
            {
              title: this.$i18n.t('attention'),
              size: "sm",
              okVariant: item.color,
              okTitle: this.$t('yes'),
              cancelTitle: this.$t('no'),
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then(async (value) => {
            if (!value) return;
            await this.UPDATE_PATCH_APPLICATION_TRANSPORT({
              status_unique: item.unique_name,
              id: props.id,
            }).then(async () => {
              await this.refresh();
            });
          });
      }
    },
    async onStatusChangedAndSaved(bvModalEvt){
      bvModalEvt.preventDefault();
      await this.$refs.confirmOrRefuseObserver.validate().then(async (success) => {
        if (!success) return;
        await this.UPDATE_PATCH_APPLICATION_TRANSPORT({
          status_unique: this.statusDeniedOrWaiting,
          status_description: this.statusComment,
          id: this.statusId,
        }).then(() => {
          this.refresh();
          this.$_okToast("success");
          this.$refs.confirmOrRefuse.hide()
        });
      })
    },
    // ===============  ON_CHANGE_STATUS_SECTION END ===============







    
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
